export default {
    fr:{
        'Etape 1':'Etape 1',
        'Etape 2':'Etape 2',
        'Etape 3':'Etape 3',
        'Êtes-vous Une Nouvelle Entreprise Sur La Plateforme?':'Êtes-vous Une Nouvelle Entreprise Sur La Plateforme?',
        'Informations de l\'entreprise':'Informations de l\'entreprise',
        'Logo de l\'entreprise':'Logo de l\'entreprise',
        'Nom de l\'entreprise':'Nom de l\'entreprise',
        'Statuts candidatures':'Statuts candidatures',
        'Statuts des candidatures par emploi':'Statuts des candidatures par emploi',
        'AO Ouverts' : 'AO Ouverts',
        'Mes appels d\'offres' : 'Mes appels d\'offres',
        'Emploi':'Emploi',
        'Adresse':'Adresse',
        'Code postal' :'Code postal',
        'Code Postal' :'Code Postal',
        'SIRET':'SIRET',
        'Recherchez votre entreprise parmi celles déjà inscrites sur High Tech Hires':'Recherchez votre entreprise parmi celles déjà inscrites sur High Tech Hires',
        'Rejoindre':'Rejoindre',
        'Saisissez le nom de l\'entreprise':'Saisissez le nom de l\'entreprise',
        'Contrat HTH':'Contrat HTH',
        'Félicitations !':'Félicitations !',
        'Votre compte a été complété avec succès. Vous recevrez un e-mail d\'activation dans les prochaines heures.':'Votre compte a été complété avec succès. Vous recevrez un e-mail d\'activation dans les prochaines heures.',
        'Home page':'Home page',
        'Mon compte':'Mon compte',
        'Compte d\'entreprise':'Compte d\'entreprise',

        'Profil d\'entreprise':'Profil d\'entreprise',
        'Documents commerciaux':'Documents commerciaux',
        'Collaborateurs de':'Collaborateurs de',
        'Créer un AO':'Créer un AO',
        'AO et Candidatures':'AO et Candidatures',
        'Templates':'Templates',
        'CVThèque':'CVThèque',
        'Trouver des CV':'Trouver des CV',
        'Mes dossiers':'Mes dossiers',
        'Propositions commerciales':'Propositions commerciales',
        'Bons de commande':'Bons de commande',
        'Missions':'Missions',
        'Compte Rendu d\'activité':'Compte Rendu d\'activité',
        'Rôle' :'Rôle',
        'Votre Intitulé du poste':'Votre Intitulé du poste',
        'Téléphone':'Téléphone',
        'Informations de compte':'Informations de compte',
        'Politique d\'authentification 2-Factor':'Politique d\'authentification 2-Factor',
        'Activer l\'authentification 2-Factor':'Activer l\'authentification 2-Factor',
        'Supprimer le compte':'Supprimer le compte',
        'Enregistrer': 'Enregistrer',
        'Données Générales':'Données Générales',
        'Données Facturation':'Données Facturation',
        'Entreprise validée par High Tech Hire le ':'Entreprise validée par High Tech Hire le ',
        'Adresse de facturation':'Adresse de facturation',
        'E-mail de facturation':'E-mail de facturation',
        'Téléphone du contact':'Téléphone du contact',
        'Numéro de la TVA':'Numéro de la TVA',
        'Taux de la TVA':'Taux de la TVA',
        'Conditions de paiement':'Conditions de paiement',
        'Payment type':'Payment type',
        'Délais de paiement':'Délais de paiement',
        'Langue des factures':'Langue des factures',
        'Ajouter d\'autres destinataires':'Ajouter d\'autres destinataires',
        'Mode d\'envoi':'Mode d\'envoi',
        'Adresse Physique':'Adresse Physique',
        'Par e-mail':'Par e-mail',
        'Coordonnées bancaires de l\'entreprise':'Coordonnées bancaires de l\'entreprise',
        'Nom de banque':'Nom de banque',
        'Données Prestation Complémentaire':'Données Prestation Complémentaire',
        'Informations Astreintes':'Informations Astreintes',
        'Astreinte “numéro”':'Astreinte “numéro”',
        'Informations HNO':'Informations HNO',
        'HNO “Numéro”':'HNO “Numéro”',
        'Tous':'Tous',
        'Ajouter un collaborateur':'Ajouter un collaborateur',
        'A définir':'A définir',
        'Admin':'Admin',
        'Responsable Achat':'Responsable Achat',
        'Comptable':'Comptable',
        'RH':'RH',
        'Actif':'Actif',
        'Votre invitation est en attente':'Votre invitation est en attente',
        'A valider':'A valider',
        'Editer':'Editer',
        'Le collaborateur a comme rôle:':'Le collaborateur a comme rôle:',
        'Créer un appel d\'offre':'Créer un appel d\'offre',
        'Recevoir et traiter les candidatures':'Recevoir et traiter les candidatures',
        'Planifier des RDV':'Planifier des RDV',
        'Valider une proposition commerciale':'Valider une proposition commerciale',
        'Ajouter et valider des collaborateurs':'Ajouter et valider des collaborateurs',
        'Valider un compte rendu d\'activité':'Valider un compte rendu d\'activité',
        'Recevoir une facture':'Recevoir une facture',
        'Modifier les paramètres de compte':'Recevoir une facture',
        'Le collaborateur est autorisé à:':'Le collaborateur est autorisé à:',

    },
    en:{
        'Etape 1':'Step 1',
        'Etape 2':'Step 2',
        'Etape 3':'Step 3',
        'Êtes-vous Une Nouvelle Entreprise Sur La Plateforme?':'Are You A New Company On Our Platform?',
        'Informations de l\'entreprise':'Company Information',
        'Logo de l\'entreprise':'Company Logo',
        'Nom de l\'entreprise':'Company Name',
        'Adresse':'Address',
        'Code postal' :'Postcode',
        'SIRET':'Company registration number',
        'Recherchez votre entreprise parmi celles déjà inscrites sur High Tech Hires':'Find your company among those already registered on our platform',
        'Rejoindre':'Join',
        'Saisissez le nom de l\'entreprise':'Enter the company name',
        'Contrat HTH':'HTH Contract',
        'Félicitations !':'Congratulations !',
        'Votre compte a été complété avec succès. Vous recevrez un e-mail d\'activation dans les prochaines heures.':'Your registration process has been successfully completed, you will receive an activation email in the next few hours.',
        'Home page':'Home page',
        'Statuts candidatures':'Application status',
        'Statuts des candidatures par emploi':'Application status per job',
        'AO Ouverts' : 'Open Jobs',
        'Mes appels d\'offres' : 'Our Jobs',
        'Emploi':'Job',
        'Mon compte':'My account',
        'Compte d\'entreprise':'Company account',
        'Profil d\'entreprise':'Company profile',
        'Documents commerciaux':'Commercial documents',
        'Collaborateurs de xxxx':'Employees of “Company name”',//#
        'Créer un AO':'Create a job',
        'AO et Candidatures':'Jobs & applications',
        'Templates':'Templates',
        'CVthèque':'CV-library',
        'Trouver des CV': 'Find resumes',
        'Mes dossiers':'My folders',
        'Propositions commerciales':'Commercial proposals',
        'Bons de commande': 'Purchase orders',
        'Missions':'Assignments',
        'Compte Rendu d\'activité':'timesheets',
        'Rôle' :'Job',
        'Votre Intitulé du poste':'Job title',
        'Téléphone':'Phone number',
        'Informations de compte':'Account information',
        'Politique d\'authentification 2-Factor':'2-Factor Authentication',
        'Activer l\'authentification 2-Factor':'Enable 2-Factor Authentication',
        'Supprimer le compte':'Delete Account',
        'Enregistrer': 'Register',
        'Données Générales':'General Information',
        'Données Facturation':'Billing Information',
        'Adresse de facturation':'Billing address',
        'E-mail de facturation':'Billing email',
        'Téléphone du contact':'Contact phone number',
        'Numéro de la TVA':'VAT number',
        'Taux de la TVA':'VAT rate',
        'Conditions de paiement':'Payment terms',
        'Payment type':'Payment type',
        'Délais de paiement':'Payment period',
        'Langue des factures':'Invoice language',
        'Ajouter d\'autres destinataires':'Add more recipients',
        'Mode d\'envoi':'Delivery method',
        'Adresse Physique':'Address',
        'Par e-mail':'By email',
        'Coordonnées bancaires de l\'entreprise':'Company bank details',
        'Nom de banque':'Bank name',
        'Données Prestation Complémentaire':'Additional Service Data',
        'Informations Astreintes':'On-call information',
        'Astreinte “numéro”':'On-call ”number”',//#
        'Informations HNO':'NWH Information',
        'HNO “Number”':'NWD “Number”',//#
        'Collaborateurs de “nom d\'entreprise”':'“company name”collaborators',//#
        'Tous':'All',
        'Ajouter un collaborateur':'Add a collaborator',
        'A définir':'To define',
        'Admin':'Admin',
        'Responsable Achat':'Purchasing Manager',
        'Comptable':'Accountant',
        'RH':'HR Manager',
        'Actif':'Active',
        'Passif':'Passive',
        'Votre invitation est en attente':'Pending invitation',
        'A valider':'To confirm',
        'Editer':'Edit',
        'Le collaborateur a comme rôle:':'The collaborator is:',
        'Créer un appel d\'offre':'Create a job',
        'Recevoir et traiter les candidatures':'Receive and process applications',
        'Planifier des RDV':'Schedule meetings',
        'Valider une proposition commerciale':'Confirm a commercial proposition',
        'Ajouter et valider des collaborateurs':'Add and approve collaborators',
        'Valider un compte rendu d\'activité':'Approve the Timesheet (TS)/propal',
        'Recevoir une facture':'Receive an invoice',
        'Modifier les paramètres de compte':'Edit Account Settings',
        'Le collaborateur est autorisé à:':'The collaborator is allowed to:',
        'Données enterprise':'Company Information',
        'Données projet':'Project Information',
        'Exigences projet':'Project Requirements',
        'Confidentielle':'Confidential',
        'Masquer le nom de l\'entreprise':'Hide the company name',
        'Manager opérationnel du projet':'Project operational manager',
        'Détails de la publication':'Publication details',
        'Référence interne':'Internal reference',
        'Date de début (publication)':'Start date (publication)',
        'Date de fin (publication)':'End date (publication)',
        'Données générales':'General information',
        'Nombre de recrutés':'Number of hires',
        'Régime de travail':'Work schedule',
        'Nb de jours/semaine':'No. of days/week',
        'Mode de travail':'Working mode',
        'A distance':'Full remote',
        'En présentiel':'Face-to-face',
        'Travail à distance':'Remote work',
        'Fréquence (télétravail)':'Frequency (occasional remote)',
        'Minimum d\'années d\'expérience':'Minimum years of experience',
        'Sous catégorie':'Sub-category',
        'Sélectionner une catégorie':'Select a category',
        'Sélectionner une sous catégorie':'Select a sub-category',
        'Durée et budget':'Duration and Budget',
        'Date de début (mission)':'Start date (assignment)',
        'Date estimée de fin (mission)':'Estimated end date (assignment)',
        'Durée de la mission (j)':'Assignment duration (days)',
        'Budget maximum/jour (en €)':'Maximum budget/day (in €)',
        'Equivalent par mois': 'Equivalent per month',
        'Visibilité du budget dans l\'AO':'Visibility of the budget in the job',
        'Equipe chargée du recrutement et/ou suivi du projet':'Team charged of recruitment and/or monitoring of the project',
        'Suivi projet':'Project tracking',
        'Compétences techniques':'Technical skills',
        'Intermédiaire':'Intermediate',
        'Minimum d\'années d\'exp.':'Minimum years of exp.',
        'Expérience plus récente':'Most recent experience',
        'Moins de 2 ans':'This year',
        'Moins de 3 ans':'Less than 3 years',
        'Ajouter une compétence':'Add a skill',
        'Compétences fonctionnelles':'Functional skills',
        'Exigence':'Requirement',
        'Sélectionner un type':'Select type',
        'Exigé':'Required',
        'Recommandé':'Recommended',
        'Félicitation!':'Congratulations! ',
        'Votre appel d\'offre a été créé avec succès sous la référence xxxxx.':'Your job offer has been successfully created under the reference xxxx.',//#
        'Une proposition des CVs les plus pertinents correspondant à votre appel d\'offre vous sera liée si des correspondances sont trouvées. Cela peut prendre quelques secondes.': 'Une proposition des CVs les plus pertinents correspondant à votre appel d\'offre vous sera liée si des correspondances sont trouvées. Cela peut prendre quelques secondes.',
        'Non, merci':'No, thank you',
        'Template':'Template',
        'Définir une template':'Define the template',
        'Entrer une nom':'Insert template name',
        'Votre appel d\'offre a été sauvegardé avec succès sous la référence xxxx.':'Your job has been successfully saved under the reference xxxx.',//#
        'Appels d\'offres ouverts':'Open Jobs',
        'Chercher ici':'Search here',
        'Code int.Client':'Client int.code',
        'Intitulé':'Title',
        // 'Statut':'Status',
        'Nb de candidatures':'No. of applications',
        'Nb de recrutement':'No. of hires',
        'Date début souhaitée':'Desired start date',
        'Date fin estimée':'Estimated end date',
        'Budget Max':'Max budget',
        'AO créé par':'Job created by',
        'Resp.opérationnel':'Operational manager',
        'Début publication':'Start publishing',
        'Fin publication':'End publishing',
        'Annuler la publication':'Cancel post',
        'Changer de statut':'Change Status',
        'Transmettre':'Transfer',
        'Candidatures':'Applications',
        'Données AO':'Job information',
        'Source de candidature':'Application source',
        'Source de Candid':'Application source',
        'Intitulé Du CV':'CV title',
        'Exp.totale':'Total exp.',
        'Exp. totale':'Total exp.',
        'Statut candidatures':'Application status',
        'Evaluation':'Evaluation',
        'Commentaires':'Comments',
        'Lue':'Read',
        'Analysée':'Reviewed',
        'À interviewer':'To interview',
        'Non Retenue':'Not selected',
        'Motif du rejet':'Reason for rejection',
        'Dépasse le budget':'Does not meet the project requirements',
        'Ne répond pas aux exigences du projet':'Ne répond pas aux exigences du projet',
        'Autre':'Other',
        'Envoyer':'Send',
        'Message':'Message',
        'Ajouter un commentaire':'Add a comment',
        'Ajoutez votre commentaire ici':'Add your comment here',
        'Date':'Date',
        'Time':'Time',
        'Durée de la réunion':'Meeting duration',
        'Transmettre des CVs':'Send CVs',
        'De:':'From:',
        'À:': 'To:',
        'Sujet:':'Subject:',
        'Vos commentaires privés sur ce CV':'Your private comments about this CV',
    },
};
